import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {SUPPORT_NOTIFICATIONS_STORAGE_KEY} from '@common/constants/storage';

interface SupportNotificationState {
  viewedTicketIds: string[];
  markViewed: (ticketId: string) => void;
  getUnviewedCount: (activeIds: string[]) => number;
}

export const useSupportNotificationStore = create<SupportNotificationState>()(
  persist(
    (set, get) => ({
      viewedTicketIds: [],
      markViewed: (ticketId: string) => {
        const current = get().viewedTicketIds;
        if (!current.includes(ticketId)) {
          set({viewedTicketIds: [...current, ticketId]});
        }
      },
      getUnviewedCount: (activeIds: string[]) => {
        const viewed = new Set(get().viewedTicketIds);
        // Clean up stale viewed IDs while computing
        const activeSet = new Set(activeIds);
        const currentViewed = get().viewedTicketIds;
        const cleaned = currentViewed.filter((id) => activeSet.has(id));
        if (cleaned.length !== currentViewed.length) {
          set({viewedTicketIds: cleaned});
        }
        return activeIds.filter((id) => !viewed.has(id)).length;
      },
    }),
    {
      name: SUPPORT_NOTIFICATIONS_STORAGE_KEY,
    },
  ),
);
